import primaryButtonActive from '../../../../../common/algorithms/primary-button-active';

const light = (params) => primaryButtonActive(params, false);

export default light;
